import axios from 'axios'
import * as utils from './api-utils'

export default {
  index() {
    return axios.get(utils.getApiUrl('/joints'))
  },
  update(id, data) {
    return axios.put(utils.getApiUrl(`/joints/${id}`), data)
  },
  updateJointNumber(id, data) {
    return axios.put(utils.getApiUrl(`/joints/${id}`), {
      joint_number: data.joint_number,
      skipUsernameUpdate: data.skipUsernameUpdate,
    })
  },
}
